import { create } from "zustand";

const usePriceListStore = create((set) => ({
    priceList: [], //jobtypes
    setPriceList: (value) => set((state) => ({...state, priceList: value}))
}));

export default usePriceListStore;
